import { render, staticRenderFns } from "./user-dropdown.vue?vue&type=template&id=24461533&scoped=true"
import script from "./user-dropdown.vue?vue&type=script&lang=js"
export * from "./user-dropdown.vue?vue&type=script&lang=js"
import style0 from "./user-dropdown.vue?vue&type=style&index=0&id=24461533&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24461533",
  null
  
)

export default component.exports